<template>
  <button :type="nativeType" :class="classes" :disabled="disabled" v-on="$listeners">
    <slot></slot>
  </button>
</template>
<script>
const prefixCls = 'vui-btn'

export default {
  name: 'VuiButton',
  props: {
    type: {
      default: 'default',
      validator (value) {
        return [
          'default',
          'primary',
          'cancel',
          'dashed',
          'text',
          'info',
          'success',
          'warning',
          'error',
        ].includes(value)
      },
    },
    size: {
      default: 'medium',
      validator (value) {
        return ['small', 'large', 'medium'].includes(value)
      },
    },
    nativeType: {
      default: 'button',
      validator (value) {
        return ['button', 'submit', 'reset'].includes(value)
      },
    },
    long: Boolean,
    round: Boolean,
    loading: Boolean,
    disabled: Boolean,
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.type}`,
        {
          [`${prefixCls}-${this.size}`]: this.size !== 'default',
          [`${prefixCls}-long`]: this.long,
          [`${prefixCls}-round`]: this.round,
          [`${prefixCls}-loading`]: this.loading,
        },
      ]
    },
  },
}
</script>

<style lang="scss">
$prefixCls: '.vui-btn';

#{$prefixCls} {
  margin: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;

  &,
  &:hover {
    outline: none;
  }

  &[disabled] {
    border-color: #f7f7f7;
    background-color: #f7f7f7;
    color: #c5c8ce;
    cursor: not-allowed;
  }

  &-long {
    width: 100%;
  }

  &-default {
    border-color: #dcdee2;
    background-color: transparent;
    color: #000;
  }

  &-warning {
    border-color: #ed6c00;
    background-color: #ed6c00;
    color: #fff;
  }

  &-cancel {
    border-color: #f9f9f9;
    background-color: #f9f9f9;
    color: #4a4a4a;
  }

  &-text {
    border-color: transparent;
    background-color: transparent;
    color: #000;
  }

  &-medium {
    padding: 6px 15px 6px 15px;
    font-size: 12px;
    line-height: 18px;
  }

  &-large {
    padding: 11px 17px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  &-medium#{$prefixCls}-round {
    border-radius: 15px;
  }

  &-large#{$prefixCls}-round {
    border-radius: 22px;
  }
}
</style>
